/* eslint-disable @typescript-eslint/no-unused-vars */
import { Input, Select, Table } from "antd";
import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useAppSelector } from "../../../app/store";
import CaretDownIcon from "../../../assets/icons/CaretDownIcon";
import CaretLeftIcon from "../../../assets/icons/CaretLeftIcon";
import CaretRightIcon from "../../../assets/icons/CaretRightIcon";
import DeleteIcon from "../../../assets/icons/DeleteIcon";
import SearchIcon from "../../../assets/icons/SearchIcon";
import StarFilledIcon from "../../../assets/icons/StarFilledIcon";
import StarIcon from "../../../assets/icons/StarIcon";
import Loader from "../../../components/ui/Loader";
import {
  useDeleteMultipleMailMutation,
  useGetMailListQuery,
  useStarredMailMutation,
} from "../../../features/superAdmin/ticketService/ticketServiceApi";
import useError from "../../../hooks/useError";
import useModal from "../../../hooks/useModal";
import useTable from "../../../hooks/useTable";
import CommonModalLayout from "../../../layouts/CommonModalLayout";
import { formatDate } from "../../../lib/time";
import { toast } from "../../../lib/toast";
import { GetMailListParamsType } from "../../../types/mail";
import { addKeyInArray } from "../../../utils/utils";
import Email from "./Email";

export default function Starred() {
  const [selectedData, setSelectedData] = useState<string[]>([]);
  const auth = useAppSelector((state) => state.auth);
  const [_, setSearchParams] = useSearchParams();
  const { open, handleOpen, handleClose } = useModal<
    { name: string; formData: object },
    "CONFIRM"
  >();
  const {
    page,
    limit,
    handleNext,
    handlePrev,
    handleLimit,
    filter,
    keyword,
    handleSearch,
  } = useTable<GetMailListParamsType>({});

  const [starredMail, { isSuccess: isMailStarredSuccess }] =
    useStarredMailMutation();
  const [
    deleteMultipleMail,
    {
      isSuccess: isDeleteMultipleMailSuccess,
      isError: isDeleteMultipleMailError,
      error: deleteMultipleMailError,
      isLoading: isDeleteMultipleMailLoading,
    },
  ] = useDeleteMultipleMailMutation();

  const handleToggleStar = (id: any) => {
    starredMail({
      id: id,
      data: {
        userId: auth?.user?.id,
      },
    });
  };

  const {
    data: getMailListData,
    isError,
    error,
    isLoading,
  } = useGetMailListQuery({
    params: {
      ...filter,
      page: page,
      id: auth?.user?.id,
      type: "starred",
      search: keyword,
    },
  });

  useError(isError, error, "Get mail list failed");
  useError(
    isDeleteMultipleMailError,
    deleteMultipleMailError,
    "Multiple mail delete failed",
  );

  const total = getMailListData?.data?.total || 0;
  const pages = getMailListData?.data?.pages || 1;

  const start = (page - 1) * limit + 1;
  const end = Math.min(page * limit, total);

  const handleDeleteMultipleEmail = () => {
    const data = {
      userId: auth.user?.id,
      mailIds: selectedData,
    };
    deleteMultipleMail({ data });
  };

  useEffect(() => {
    if (isDeleteMultipleMailSuccess) {
      toast("success", "Email deleted successfully!");
      handleClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDeleteMultipleMailSuccess]);

  useEffect(() => {
    if (isMailStarredSuccess) {
      toast("success", "Success");
    }
  }, [isMailStarredSuccess]);
  let basePath = "/user/communication/email";
  if (auth?.role === "super_admin" || auth?.role === "Admin") {
    basePath = "/admin/communication/email";
  }
  const columns = [
    {
      render: (value: any) => {
        const isSender = auth?.user?.id === value?.sender_id;
        const isReceiver = auth?.user?.id === value?.receiver_id;
        const matchedBccUser = value?.bcc_users?.find(
          (user: any) => user?.MailUserBcc?.user_id === auth?.user?.id,
        );
        const isStarredBcc = matchedBccUser?.MailUserBcc?.is_starred;

        const matchedCcUser = value?.cc_users?.find(
          (user: any) => user?.MailUserCc?.user_id === auth?.user?.id,
        );
        const isStarredCc = matchedCcUser?.MailUserCc?.is_starred;

        if (isSender) {
          return (
            <div
              className="cursor-pointer"
              onClick={() => handleToggleStar(value.id)}
            >
              {value.is_starred_by_sender === true ? (
                <StarFilledIcon />
              ) : (
                <StarIcon />
              )}
            </div>
          );
        } else if (isReceiver) {
          return (
            <div
              className="cursor-pointer"
              onClick={() => handleToggleStar(value.id)}
            >
              {value.is_starred_by_receiver === true ? (
                <StarFilledIcon />
              ) : (
                <StarIcon />
              )}
            </div>
          );
        } else if (matchedBccUser) {
          return (
            <div
              className="cursor-pointer"
              onClick={() => handleToggleStar(value.id)}
            >
              {isStarredBcc === true ? <StarFilledIcon /> : <StarIcon />}
            </div>
          );
        } else {
          return (
            <div
              className="cursor-pointer"
              onClick={() => handleToggleStar(value.id)}
            >
              {isStarredCc === true ? <StarFilledIcon /> : <StarIcon />}
            </div>
          );
        }
      },
    },
    {
      render: (val: any) => {
        const sameUserName = val?.sender_id === val?.receiver_id;

        if (sameUserName && val?.is_draft === false) {
          return (
            <Link
              to={`${basePath}/starred/${val.id}`}
              className="cursor-pointer font-semibold"
            >
              <span className="font-semibold">Me</span>
            </Link>
          );
        } else if (sameUserName && val?.is_draft === true) {
          return (
            <div
              onClick={() => setSearchParams({ mail_id: val?.id })}
              className="cursor-pointer font-semibold"
            >
              <span className="font-semibold text-red-500">Draft</span>
            </div>
          );
        } else if (val?.is_draft === true) {
          return (
            <div
              onClick={() => setSearchParams({ mail_id: val?.id })}
              className="cursor-pointer font-semibold"
            >
              <span className="font-semibold text-red-500">Draft</span>
            </div>
          );
        } else {
          return (
            <Link
              to={`${basePath}/starred/${val.id}`}
              className="cursor-pointer font-semibold"
            >
              <span className="font-semibold">
                {val.sender.officialInfo.name}
              </span>
            </Link>
          );
        }
      },
    },
    {
      render: (val: any) => {
        const reply = val?.replies?.[0];

        if (val?.is_draft === true) {
          return (
            <div
              onClick={() => setSearchParams({ mail_id: val?.id })}
              className="cursor-pointer font-semibold"
            >
              {reply?.subject || val.subject} - {reply?.body || val.body}
            </div>
          );
        } else {
          return (
            <Link
              to={`${basePath}/starred/${val.id}`}
              className="cursor-pointer font-semibold"
            >
              {reply?.subject || val.subject} - {reply?.body || val.body}
            </Link>
          );
        }
      },
    },
    {
      render: (val: any) => (
        <span className="text-gray-500">
          {/* {new Date(val.created_at).toISOString().split("T")[0]} */}
          {formatDate(val.created_at)}
        </span>
      ),
    },
  ];

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      {open?.type === "CONFIRM" && (
        <CommonModalLayout
          title="Are you sure mail deleted?"
          deleteButton
          open={open?.open}
          handleClose={handleClose}
          handleAction={handleDeleteMultipleEmail}
          alertRedIcon
          cancelButton
          loading={isDeleteMultipleMailLoading}
        />
      )}

      <Email>
        <div>
          <Input
            size="large"
            placeholder="Search by mail body"
            prefix={<SearchIcon />}
            // suffix={<FilterIcon />}
            onChange={handleSearch}
          />
        </div>

        <div className="mt-4 border border-[#D7DFE9] rounded-md p-4">
          <div className="flex justify-between gap-4 items-center">
            <div className="flex justify-start gap-4 items-center">
              <span className="cursor-pointer">
                {/* <UnreadMailIcon color="#5E718D" /> */}
              </span>
              <span
                onClick={() => {
                  if (selectedData.length === 0) {
                    toast("error", "Please select at least one mail !");
                    return;
                  }
                  handleOpen({
                    type: "CONFIRM",
                  });
                }}
                className="cursor-pointer"
              >
                <DeleteIcon color="#5E718D" />
              </span>
            </div>

            <div className="flex justify-end gap-4 items-center">
              <div>{`${start}-${end} of ${total}`}</div>
              <div className="flex gap-2 items-center">
                <span
                  onClick={handlePrev}
                  className={`cursor-pointer ${
                    page <= 1 ? "opacity-50 pointer-events-none" : ""
                  }`}
                >
                  {" "}
                  <CaretLeftIcon />
                </span>

                <span
                  onClick={handleNext}
                  className={`cursor-pointer ${
                    page >= pages ? "opacity-50 pointer-events-none" : ""
                  }`}
                >
                  <CaretRightIcon />
                </span>
              </div>
              <div>
                <Select
                  placeholder="10"
                  suffixIcon={<CaretDownIcon />}
                  size="small"
                  style={{ width: 70 }}
                  onChange={handleLimit}
                  options={[
                    { label: "10", value: 10 },
                    { label: "20", value: 20 },
                    { label: "50", value: 50 },
                    { label: "100", value: 100 },
                    { label: "1000", value: 1000 },
                  ]}
                />
              </div>
            </div>
          </div>
          {/* <Tabs defaultActiveKey="primary" items={items} /> */}

          <div className="mt-4">
            <Table
              className="custom-table custom-scrollbar"
              columns={columns}
              dataSource={addKeyInArray(getMailListData?.data?.mails)}
              pagination={false}
              rowSelection={{
                type: "checkbox",
                selectedRowKeys: selectedData,
                onChange: (key) => {
                  setSelectedData(key as string[]);
                },

                columnWidth: 40,
              }}
            />
          </div>
        </div>
      </Email>
    </>
  );
}
